export default __webpack_public_path__ + "static/media/gaurav-rane.4f25ee67.jpg";